import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "preact/jsx-runtime";
import { useContext, useRef } from 'react';
import ReactDOM from 'react-dom';
import useOnScreen from 'pathfinder/modules/shared/useOnScreen';
import { ADD_TO_MY_FANDOMS_MODULES_VARIANTS } from 'pathfinder/rules-engine/modules/addToMyFandoms';
import styles from './DesktopStickyButton.module.scss';
import { Tooltip } from './Tooltip';
import { TooltipContext } from './Context';
import { SmallHeartIcon } from './icons';
export const DesktopStickyButton = ({ isAlreadyAdded, handleClick, root, variant }) => {
    const buttonRef = useRef(null);
    const isOnScreen = useOnScreen(buttonRef);
    const { onFollow } = useContext(TooltipContext);
    const classNames = ['wds-button', styles.button];
    switch (variant) {
        case ADD_TO_MY_FANDOMS_MODULES_VARIANTS.VARIANT1:
            classNames.push('wds-is-secondary');
            classNames.push(styles.variant1);
            break;
        case ADD_TO_MY_FANDOMS_MODULES_VARIANTS.VARIANT2:
            classNames.push('wds-is-secondary');
            classNames.push(styles.variant2);
            break;
        case ADD_TO_MY_FANDOMS_MODULES_VARIANTS.VARIANT3:
            classNames.push(styles.variant3);
            break;
        case ADD_TO_MY_FANDOMS_MODULES_VARIANTS.VARIANT4:
            classNames.push(styles.variant4);
            break;
    }
    // button in the sticky header should not be focusable - so let's remove the focus
    const onClick = (e) => {
        e.preventDefault();
        buttonRef.current.blur();
        onFollow(handleClick());
    };
    const wrapper = (_jsxs(_Fragment, { children: [_jsxs("button", Object.assign({ className: classNames.join(' '), onClick: onClick, ref: buttonRef }, { children: [_jsx("span", Object.assign({ className: styles.label }, { children: isAlreadyAdded ? 'Following' : 'Follow' }), void 0), _jsx(SmallHeartIcon, { className: styles.icon, isFilled: isAlreadyAdded }, void 0)] }), void 0), _jsx(Tooltip, { variant: "desktop-sticky", isOnScreen: isOnScreen }, void 0)] }, void 0));
    return ReactDOM.createPortal(wrapper, root);
};
